import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {useVIP} from '../../hook'
import {Link} from 'react-router-dom'
import {useDeleteVIPTier} from '../../context/useMutation'
import {Modal} from 'react-bootstrap'
import {useState} from 'react'

const VIPList = ({
  loading,
  isProgress,
  refetch,
  entryMethodType,
}: {
  loading: boolean
  isProgress: boolean
  refetch: () => void
  entryMethodType: number
}) => {
  const intl = useIntl()
  const {VIPList, VIPListSet} = useVIP()
  const {mutateAsync} = useDeleteVIPTier()
  const [deleteId, setDeleteId] = useState<string>('')

  const handleDelete = async (id: string) => {
    await mutateAsync({id})
    refetch()
  }

  const columns = [
    {
      key: 'name',
      dataIndex: 'name',
      title: intl.formatMessage({id: 'VIP.TABLE.TIER'}),
      render: (text: string, record: any) => {
        return (
          <div className='d-flex align-items-center fs-6 text-black'>
            <i className='bi bi-gem fs-3 text-black me-3'></i>
            {record.name}
          </div>
        )
      },
    },
    {
      key: 'value',
      dataIndex: 'value',
      title: intl.formatMessage({id: 'VIP.TABLE.REQUIREMENT'}),
      render: (text: string, record: any) => {
        return (
          <span className='fs-6 text-black'>
            {entryMethodType === 1
              ? intl.formatMessage({id: 'VIP.TABLE.REQUIREMENT.POINT'}, {point: record.value})
              : entryMethodType === 2
              ? intl.formatMessage({id: 'VIP.TABLE.REQUIREMENT.AMOUNT'}, {point: record.value})
              : intl.formatMessage({id: 'VIP.TABLE.REQUIREMENT.NUMBER'}, {point: record.value})}
          </span>
        )
      },
    },
    {
      key: 'customerCount',
      dataIndex: 'customerCount',
      title: intl.formatMessage({id: 'VIP.TABLE.MEMBER'}),
      render: (text: string, record: any) => {
        return <span className='fs-6 text-black'>{record.customerCount}</span>
      },
    },
    {
      key: 'action',
      dataIndex: 'action',
      title: '',
      render: (text: string, record: any) => {
        return (
          <div className='d-flex justify-content-center gap-5'>
            {isProgress ? (
              <button className='btn btn-primary' disabled={true}>
                {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
              </button>
            ) : (
              <Link
                to={`/vip/edit/${record.id}?tier=${record.name}`}
                className='text-decoration-none'
              >
                <button className='btn btn-primary'>
                  {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
                </button>
              </Link>
            )}
            <button
              className='btn btn-danger'
              disabled={isProgress}
              onClick={() => {
                setDeleteId(record.id)
              }}
            >
              {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
            </button>
          </div>
        )
      },
    },
  ]

  return (
    <>
      <Modal show={deleteId !== ''} onHide={() => setDeleteId('')} backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage({id: 'VIP.TABLE.TIER.DELETE'})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{intl.formatMessage({id: 'VIP.TABLE.TIER.DELETE.DESC'})}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-light' onClick={() => setDeleteId('')}>
            {intl.formatMessage({id: 'CANCEL'})}
          </button>
          <button
            className='btn btn-danger'
            onClick={() => {
              handleDelete(deleteId)
              setDeleteId('')
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
          </button>
        </Modal.Footer>
      </Modal>
      <Table
        loading={loading}
        dataSource={VIPList.data}
        columns={columns}
        tableName={'vipList'}
        pagination={{
          current: VIPList.paging.currentPageNumber,
          pageSize: VIPList.paging.pageSize,
          total: VIPList.paging.totalCount,
          onChange: (pagination: {current: number; pageSize: number}) => {
            VIPListSet({
              ...VIPList,
              paging: {
                ...VIPList.paging,
                currentPageNumber: pagination.current,
                pageSize: pagination.pageSize,
              },
            })
          },
        }}
      />
    </>
  )
}

export default VIPList
